import http from '../services/http';
import { typeAs } from '../services/utils';

export default {
  namespaced: true,

  state: {
    navigation: null,
  },

  mutations: {
    INIT_NAVIGATION(state) {
      state.navigation = {};
    },
    CLEAR_NAVIGATION(state) {
      state.navigation = null;
    },
    SET_NAVIGATION(state, data) {
      state.navigation = data;
    },
  },

  actions: {
    clear({ commit }) {
      commit('CLEAR_NAVIGATION');
    },

    find({ commit }) {
      return http('/navigations')
        .then((response) => response.body)
        .then(typeAs('Navigation'))
        .then((response) => {
          commit('SET_NAVIGATION', response);
          return response;
        });
    },

    save(_, {
      id, ...data
    }) {
      const request = http('/navigations', { method: 'PUT', data });

      return request.then((response) => response.body.item);
    },

    publish({ dispatch }, article) {
      return dispatch('save', {
        id: article.id,
        published: true,
        action: 'publish',
      });
    },
  },
};
